import "../css/style.scss"

// Our modules / classes
import MobileMenu from "./modules/MobileMenu"
const mobileMenu = new MobileMenu()

import MobileSubMenu from "./modules/MobileSubMenu"
const mobileSubMenu = new MobileSubMenu()

import ScrollHandler from "./modules/ScrollHandler";
const scrollHandler = new ScrollHandler();

/*import Loaded from '../gutenberg/gutenberg-blocks/custom-services/loaded';
const loaded = new Loaded();*/

/*import ParallaxEffect from '../gutenberg/gutenberg-blocks/custom-parallax/CustomParallax';
const parallax = new ParallaxEffect();*/

import ServicesDescription from '../gutenberg/gutenberg-blocks/services-description/ServicesDescription';

document.addEventListener('DOMContentLoaded', () => {
    new ServicesDescription();
});

import CustomServices from '../gutenberg/gutenberg-blocks/custom-services/custom-services';
document.addEventListener("DOMContentLoaded", function () {
    const animator = new CustomServices();
    animator.initAnimations();
});

import PreloaderHandler from "./modules/PreloaderHandler"
const preloaderHandler = new PreloaderHandler()

/*import ScrollTigerTextReveal from "./modules/ScrollTigerTextReveal"
const scrollTigerTextReveal = new ScrollTigerTextReveal()*/

import TextFilledOnScroll from "./modules/TextFilledOnScroll"
const textFilledOnScroll = new TextFilledOnScroll()

/*import ImageReveal from "./modules/ImageReveal"
const imageReveal = new ImageReveal()*/

//import TextRevealPerspective from "./modules/TextRevealPerspective"
//const textRevealPerspective = new TextRevealPerspective()

import TextReveal from "./modules/TextReveal"
const textReveal = new TextReveal('.my-text');
import HomePortfolio from '../gutenberg/gutenberg-blocks/home-portfolio/HomePortfolio';
//import HomePortfolio from './modules/HomePanelPortfolio';
import DataEffect21 from "./modules/DataEffect21"
document.addEventListener('DOMContentLoaded', function() {
    const homePortfolio = new HomePortfolio();
    const effect21 = new DataEffect21();
    effect21.applyEffect();
});

import DataEffect27 from "./modules/DataEffect27"
//const dataEffect27 = new DataEffect27()
new DataEffect27('[data-splitting][data-effect27]');
//
/*import ScrollTransAnimation from './modules/scrollTransAnimation';
const scrollTransAnimation = new ScrollTransAnimation()
new ScrollTransAnimation('div[data-splitting][data-effect0]');*/
